if (!customElements.get('personalize-modal')) {
  customElements.define(
    'personalize-modal',
    class PersonalizeModal extends ModalDialog {
      constructor() {
        super();
        this.personalizeForm = this.querySelector('personalize-form');
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
      }

      show(opener) {
        super.show(opener);
        this.opened = true;

        this.personalizeForm.handleOpenModal();
      }

      hide() {
        super.hide();
        this.personalizeForm.unsetPersonalizationUrl();
        this.opened = false;
      }

      isOpen() {
        return this.opened || false;
      }
    }
  );
}

if (!customElements.get('personalize-image')) {
  customElements.define(
    'personalize-image',
    class PersonalizeImage extends HTMLElement {
      constructor() {
        super();

        this.personalizeModal = this.closest('personalize-modal');
        this.personalizeForm = this.personalizeModal.querySelector('personalize-form');
        this.imageWrapper = this.querySelector('image-wrapper');

        this.personalizationText = this.querySelector('#personalization-text');
        // the shadow element is the copy of original element that inherit all styles and methods
        // except the ones with resize. this block should not change its size in updateTextFontSize method
        this.shadowPersonalizationText = this.querySelector('#personalization-text[data-purpose="personalization-text-shadow"]');

        this.fontMounted = false;

        this.eventListeners();
      }

      eventListeners() {
        window.addEventListener('resize', this.updateTextFontSize.bind(this));
      }

      updateTextFontSize() {
        // method for scaling down preview line container when it's not fitting in the approx photo size
        if (!this.personalizeForm.inputs.fonts[0].value) return;

        const selectedFont = (Object.fromEntries(new URLSearchParams(location.search)).font
          || this.personalizeForm.querySelector(`${this.personalizeForm.inputStrings.font}:checked`)?.value
          || this.personalizeForm.inputs.fonts[0].value);

        if (!this.personalizeForm.inputs.line1?.value && !this.personalizeForm.inputs.line2?.value) {
          this.personalizationText .classList.add('font-size-analyzed');
          this.shadowPersonalizationText.classList.add('font-size-analyzed');
        }

        // checking whether font is downloaded
        if (!document.fonts.check(`12px ${selectedFont}`)) {
          this.fontMounted = false;
        }

        if (!this.fontMounted) {
          setTimeout(() => this.updateTextFontSize(), 500);
          this.fontMounted = document.fonts.check(`12px ${selectedFont}`);
          return;
        }

        this.personalizationText .classList.add('font-size-analyzed');
        this.shadowPersonalizationText.classList.add('font-size-analyzed');

        const wrapperWidth = this.querySelector('#personalization-text-container').offsetWidth;
        const line1Preview = this.personalizationText.querySelector(`[id$=line-1-value]`);
        const line2Preview = this.personalizationText.querySelector(`[id$=line-2-value]`);
        const shadowLine1Preview = this.shadowPersonalizationText.querySelector(`[id$=line-1-value]`);
        const shadowLine2Preview = this.shadowPersonalizationText.querySelector(`[id$=line-2-value]`);
        const shadowWrapperInitialScale = Number(getComputedStyle(this.shadowPersonalizationText).transform?.match(/-?\d*\.?\d+/g) ? getComputedStyle(this.shadowPersonalizationText).transform?.match(/-?\d*\.?\d+/g)[0] : 1);
        let fontSizeVariable = 0;

        const greaterWidth = shadowLine1Preview.offsetWidth > shadowLine2Preview.offsetWidth
          ? shadowLine1Preview.offsetWidth
          : shadowLine2Preview.offsetWidth;

        // regardless of the initial scale - reset it
        this.personalizationText.style.scale = ( 1 / shadowWrapperInitialScale );

        if ((wrapperWidth) < (greaterWidth * shadowWrapperInitialScale)) {
          fontSizeVariable = (wrapperWidth / greaterWidth);
        } else {
          fontSizeVariable = shadowWrapperInitialScale;
        }

        line1Preview.style.fontSize = `${ Number(getComputedStyle(shadowLine1Preview).fontSize.match(/-?\d*\.?\d+/g)[0] || '30') * fontSizeVariable }px`;
        line2Preview.style.fontSize = `${ Number(getComputedStyle(shadowLine2Preview).fontSize.match(/-?\d*\.?\d+/g)[0] || '30') * fontSizeVariable }px`;
      }

      updateFontStyles() {
        const values = this.personalizeForm.getValues(this.personalizeForm);
        this.personalizationText.classList = '';
        this.shadowPersonalizationText.classList = '';

        if (values.font) {
          this.personalizationText.classList += `font-${values.font.toLowerCase()} `;
          this.shadowPersonalizationText.classList += `font-${values.font.toLowerCase()} `;
        }

        if (values.threadColor) {
          this.personalizationText.classList += `thread-${values.threadColor.replaceAll(' ', '-').toLowerCase()} `;
          this.shadowPersonalizationText.classList += `thread-${values.threadColor.replaceAll(' ', '-').toLowerCase()} `;
        }

        if (values.type) {
          this.personalizationText.classList += `type-${values.type.toLowerCase()} `;
          this.shadowPersonalizationText.classList += `type-${values.type.toLowerCase()} `;
        }
      }

      updateText(personalizationText) {
        const line1Preview = personalizationText.querySelector(`[id$=line-1-value]`);
        const line1Value = this.personalizeForm.querySelector('.property__input--line-1')?.value || '';
        const line2Preview = personalizationText.querySelector(`[id$=line-2-value]`);
        const line2Value = this.personalizeForm.querySelector('.property__input--line-2')?.value || '';
        const lineValueArr = [
          { linePreview: line1Preview, lineValue: line1Value },
          { linePreview: line2Preview, lineValue: line2Value }
        ];

        lineValueArr.forEach(item => {
          const { linePreview, lineValue } = item;

          if (linePreview && lineValue.length > 0) {
            linePreview.innerHTML = lineValue
              .split('')
              .map((el, i) => `<span class="char char-${i}${el === ' ' ? ' char-empty' : ''}">${el}</span>`)
              .join('');
          } else {
            linePreview.innerHTML = '';
          }
        })
      }

      showActiveMedia() {
        const mediaGallery = document.querySelector(`[id^="MediaGallery-${this.personalizeForm.section}"]`);
        const activeMedia = mediaGallery.querySelector('.product__media-list .product__media-item img');
        const currentMedia = this.imageWrapper.querySelector('img');

        if (currentMedia?.src === activeMedia.src) return;

        const newImage = activeMedia.cloneNode();

        if (currentMedia) this.imageWrapper.removeChild(currentMedia);

        newImage.setAttribute('sizes', '');
        newImage.classList = '';
        this.imageWrapper.appendChild(newImage);
      }
    }
  );
}

if (!customElements.get('personalize-form')) {
  customElements.define(
    'personalize-form',
    class PersonalizeForm extends HTMLElement {
      constructor() {
        super();

        this.section = this.dataset.sectionId;
        this.productType = this.dataset.productType;
        this.preview = this.dataset.preview === 'true' ? true : false;
        this.personalizationType = this.dataset.personalizationType || null;
        this.dataUpdateUrl = JSON.parse(this.dataset.updateUrl || 'false');
        this.itemPersonalized = JSON.parse(this.dataset.itemPersonalized || 'false');

        this.addButton = this.querySelector('button[name="add_with_personalization"]');
        this.nextButton = this.querySelector('[id^="Next-"]');
        this.productInfo = document.querySelector(`[id^="ProductInfo-${this.section}"]`);
        this.personalizeButton = this.productInfo.querySelector('.button--personalize');
        this.removeButton = this.productInfo.querySelector('[data-remove-personalization]');
        this.classicAddButton = this.productInfo.querySelector('product-form [name="add"]');

        this.confirmationModalOpener = this.productInfo.querySelector('.product-confirmation-modal__button')?.closest('modal-opener');
        this.disableConfirmationModalValue = false;
        this.addToRegistryCTAs = document.querySelectorAll('add-to-registry');

        this.personalizeModal = this.closest('personalize-modal');
        this.personalizeImage = this.personalizeModal.querySelector('personalize-image');
        this.personalizeImageWrapper = this.personalizeImage.querySelector('image-wrapper');

        // variables to manage thread groups
        this.mainThreadGroup = this.querySelector('[data-recommended-threads-main]');
        this.additionalThreadGroup = this.querySelector('[data-recommended-threads-additional]');
        this.fabricsData = JSON.parse(document.getElementById('recommended-threads-data')?.textContent || 'null');
        this.fabricsInOptionsIndex = JSON.parse(this.dataset.fabricInOptionsIndex || '0');

        this.alphabet = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
        this.numbers = ['0','1','2','3','4','5','6','7','8','9'];
        this.generallyAccessibleCharacters = ['.', ',', '?', ';', ':', '!', '$', '&', '+', '[', ']', '{', '}', '|', '#', '‘', '’', '“', '”', `'`, `"`, '-'];
        this.restCharactersOnKeyboard = ['=', '/', '\\', '<', '>', '@', '*', '%', '^', '(', ')', '`', '_', ''];
        this.defaultEnabledCharacters = [...this.alphabet, ...this.numbers, ' '];

        // general fonts
        this.TillmanEnabledCharacters = [...this.defaultEnabledCharacters, ...this.generallyAccessibleCharacters];
        this.MiramarEnabledCharacters = [...this.defaultEnabledCharacters, ...this.generallyAccessibleCharacters];
        this.WaterfordEnabledCharacters = [...this.defaultEnabledCharacters, ...this.generallyAccessibleCharacters];
        this.CrawfordEnabledCharacters = [...this.defaultEnabledCharacters, ...this.generallyAccessibleCharacters];
        this.SpringEnabledCharacters = [...this.defaultEnabledCharacters, ...this.generallyAccessibleCharacters];
        this.HavenEnabledCharacters = [...this.defaultEnabledCharacters, ...this.generallyAccessibleCharacters];

        // monogram fonts
        this.HudsonEnabledCharacters = [...this.defaultEnabledCharacters];
        this.EastlakeEnabledCharacters = [...this.defaultEnabledCharacters];
        this.FleurEnabledCharacters = [...this.defaultEnabledCharacters];

        // retired fonts (available only on Padlocks)
        this.WarsonEnabledCharacters = [...this.defaultEnabledCharacters, ...this.generallyAccessibleCharacters, ...this.restCharactersOnKeyboard];
        this.HeritageEnabledCharacters = [...this.defaultEnabledCharacters, ...this.generallyAccessibleCharacters, ...this.restCharactersOnKeyboard];
        this.LouisEnabledCharacters = [...this.defaultEnabledCharacters, ...this.generallyAccessibleCharacters, ...this.restCharactersOnKeyboard];

        this.fontsEnabledCharacters = {
          'Tillman': this.TillmanEnabledCharacters,
          'Miramar': this.MiramarEnabledCharacters,
          'Waterford': this.WaterfordEnabledCharacters,
          'Crawford': this.CrawfordEnabledCharacters,
          'Spring': this.SpringEnabledCharacters,
          'Haven': this.HavenEnabledCharacters,
          'Hudson': this.HudsonEnabledCharacters,
          'Eastlake': this.EastlakeEnabledCharacters,
          'Fleur': this.FleurEnabledCharacters,
          'Warson': this.WarsonEnabledCharacters,
          'Heritage': this.HeritageEnabledCharacters,
          'Louis': this.LouisEnabledCharacters
        }

        this.inputStrings = {
          embroidery: 'input[name="Embroidery"]',
          embossing: 'input[name="Embossing"]',
          engraving: 'input[name="Personalization"]',
          embroideryCheckbox: 'input[name="properties[_Embroidery]"]',
          engravingCheckbox: 'input[name="properties[_Engraving]"]',
          foilStampCheckbox: 'input[name="properties[_Foil Stamp]"]',
          type: 'input[name="properties[Embroidery Type]"]',
          font: 'input[name="properties[Font]"]',
          threadColor: 'input[name="properties[Thread Color]"]',
          foilColor: 'input[name="properties[Foil Color]"]',
          line1: 'input[name="properties[Line 1]"]',
          line2: 'input[name="properties[Line 2]"]',
        };

        this.inputs = {
          embroidery: document.querySelectorAll(`${this.inputStrings.embroidery}`),
          embroideryCheckbox: this.querySelectorAll(`${this.inputStrings.embroideryCheckbox}`),
          foilStampCheckbox: this.querySelectorAll(`${this.inputStrings.foilStampCheckbox}`),
          types: this.querySelectorAll(`${this.inputStrings.type}`),
          fonts: this.querySelectorAll(`${this.inputStrings.font}`),
          threadColors: this.querySelectorAll(`${this.inputStrings.threadColor}`),
          line1: this.querySelector(`${this.inputStrings.line1}`),
          line2: this.querySelector(`${this.inputStrings.line2}`),
        };

        this.propertyInputsArray = [
          ...Array.from(this.inputs.threadColors),
          ...Array.from(this.inputs.types),
          ...Array.from(this.inputs.fonts)
        ]

        this.eventListeners();
      }

      eventListeners() {
        this.addEventListener('input', debounce(this.handleChange.bind(this), 250));

        this.inputs.line1?.addEventListener('input', (e) => debounce(this.handleInputChange.bind(this, e), 10));
        this.inputs.line2?.addEventListener('input', (e) => debounce(this.handleInputChange.bind(this, e), 10));

        this.removeButton.addEventListener('click', this.removePersonalization.bind(this));

        if (this.productInfo?.closest('section')?.id.indexOf('bundle') < 0 && document.querySelector('variant-radios')) {
          document.querySelector('variant-radios').addEventListener('variant-changed', () => {
            this.values = this.getValues();
            this.updateUrl(true);
            this.handlePersonalizeButton();
          });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.handleNextButton.bind(this));
        }
      }

      connectedCallback() {
        this.checkPersonalizeUrl();
        this.deletePersonalizationIfValuesEmpty();
        this.initThreadGroups();
      }

      handleOpenModal() {
        this.getProductData();
        this.scrollUpAndHideHeader()

        if (this.productType == 'trunks'
          || this.productType == 'heirloom-gown'
          || this.productType == 'heirloom-blanket'
          || this.productType == 'crown'
          || this.productType == 'pouches'
          || this.productType == 'basket'
          || this.productType == 'easter-basket'
        ) {
          this.setInitialValues(this.productType == 'easter-basket' || this.productType == 'pouches' ? 'monogram' : null);
        } else if (this.productType == 'accessory-bundle'
          || this.productType == 'luggage-tag'
          || this.productType == 'card-case'
          || this.productType == 'vanity-case'
        ) {
          this.setFoilStampAndEngravingValues();
        } else if (this.productType == 'heart-padlock') {
          this.setInitialValues();
        }

        this.handleChange();
        this.setPersonalizationUrl();
        this.personalizeImage.showActiveMedia();

        if (this.inputs.line1) {
          this.updateCharacterCount(this.inputs.line1, `${this.section}-line-1`);
        }

        if (this.inputs.line2) {
          this.updateCharacterCount(this.inputs.line2, `${this.section}-line-2`);
        }
      }

      handleChange(e) {
        this.values = this.getValues();

        this.updateUrl();
        this.updateInputs();
        this.updateButtonStyles();
        this.updateLegends();
        this.handleFontChange(e);

        this.personalizeImage.updateFontStyles();
        this.personalizeImage.updateTextFontSize();
      }

      handleInputChange(e) {
        e.target.value = this.removeDisabledCharacters({ value: e.target.value });

        this.updateCharacterCount(e.currentTarget);

        if (this.preview) this.personalizeImage.updateText(this.personalizeImage.personalizationText)
        if (this.preview) this.personalizeImage.updateText(this.personalizeImage.shadowPersonalizationText);
        if (this.productType == 'pouches') this.setInitials(e);

        this.handleChange();
        this.handleInputsChange(!this.inputs.line1?.value && !this.inputs.line2?.value)
      }

      handleFontChange(e) {
        if (!e || e.target.getAttribute('name') === 'properties[Thread Color]') return;

        // handle change of disabled characters according to the new font
        if (this.inputs.line1) {
          this.inputs.line1.value = this.removeDisabledCharacters({ value: this.inputs.line1.value });
          this.updateCharacterCount(this.inputs.line1, `${this.section}-line-1`);
        }

        if (this.inputs.line2) {
          this.inputs.line2.value = this.removeDisabledCharacters({ value: this.inputs.line2.value });
          this.updateCharacterCount(this.inputs.line2, `${this.section}-line-2`);
        }

        if (this.preview) this.personalizeImage.updateText(this.personalizeImage.personalizationText)
        if (this.preview) this.personalizeImage.updateText(this.personalizeImage.shadowPersonalizationText);
        this.handleInputsChange(!this.inputs.line1?.value && !this.inputs.line2?.value);
      }

      handleInputsChange(inputsEmpty) {
        this.itemPersonalized = !inputsEmpty;

        this.values = this.getValues();

        let embroideryOrEmbossingChecker = '';
        let embroideryVariantRadio = null;

        if (this.productType == 'trunks'
          || this.productType == 'heirloom-gown'
          || this.productType == 'heirloom-blanket'
          || this.productType == 'crown'
          || this.productType == 'pouches'
          || this.productType == 'basket'
          || this.productType == 'easter-basket'
        ) {
          embroideryOrEmbossingChecker = inputsEmpty ? '[value="No Embroidery"]' : '[value="Embroidery"]';
          embroideryVariantRadio = this.productInfo.querySelector(`${this.inputStrings.embroidery}${embroideryOrEmbossingChecker}`);

        } else if (this.productType == 'heart-padlock' || this.productType == 'accessory-bundle') {
          this.querySelector(`${this.inputStrings.engravingCheckbox}[value="Yes"]`).checked = !inputsEmpty;

        } else if (this.personalizationType == 'foil-stamp'
          || this.productType == 'milestone-book'
          || this.productType == 'luggage-tag'
          || this.productType == 'card-case'
          || this.productType == 'vanity-case'
        ) {
          embroideryOrEmbossingChecker = inputsEmpty ? '[value="No Embossing"]' : '[value="Embossing"]';
          embroideryVariantRadio = this.productInfo.querySelector(`${this.inputStrings.embossing}${embroideryOrEmbossingChecker}`);
        }

        if (embroideryVariantRadio) {
          embroideryVariantRadio.checked = true;
        }

        if (this.querySelector(`${this.inputStrings.embroideryCheckbox}[value="Yes"]`)) {
          this.querySelector(`${this.inputStrings.embroideryCheckbox}[value="Yes"]`).checked = !inputsEmpty;
        }

        if (this.querySelector(`${this.inputStrings.foilStampCheckbox}[value="Yes"]`)) {
          this.querySelector(`${this.inputStrings.foilStampCheckbox}[value="Yes"]`).checked = !inputsEmpty;
        }

        if (this.querySelector(`${this.inputStrings.foilColor}[value="Gold"]`)) {
          this.querySelector(`${this.inputStrings.foilColor}[value="Gold"]`).checked = !inputsEmpty;
        }

        // disable inputs before first interaction with line inputs
        // to prevent adding product with personalization properties but without personalization to the cart
        // e.g (Trunk - No Personalization, Font Miramar, Thread Yellow)
        if (this.itemPersonalized) {
          this.enableInputs();
        } else {
          this.temporaryDisableInputs();
        }

        if (this.productInfo.querySelector('variant-radios')) {
          this.productInfo.querySelector('variant-radios').onVariantChange();
        }

        this.handlePersonalizeButton();
      }

      removeDisabledCharacters({ value, fontName, type } = {}) {
        const currentFont = this?.values?.font || fontName;
        const currentType = this?.values?.type || type;
        const currentFontEnabledCharacters = currentType === 'Text' ? (this.fontsEnabledCharacters[currentFont] || this.defaultEnabledCharacters) : this.defaultEnabledCharacters;

        value.split('').forEach(char => {
          if (currentFontEnabledCharacters.includes(char)) return;
          value = value.replaceAll(char, '');
        })

        return value;
      }

      handlePersonalizeButton() {
        const personalizePrice = this.personalizeButton.getAttribute('data-personalize-price') || '';

        this.personalizeButton.querySelector('.label').textContent = this.itemPersonalized ? 'Edit personalization' : `Personalize ${personalizePrice}`;
        this.removeButton.classList.toggle('hidden', !this.itemPersonalized);

        if (this.confirmationModalOpener && !this.disableConfirmationModalValue) {
          this.toggleConfirmationModal(this.itemPersonalized);
        }
      }

      scrollUpAndHideHeader() {
        if (window.innerWidth > 960) return
        window.scrollTo(0, 600);
        setTimeout(() => document.querySelector('sticky-header').hide(), 300);
      }

      toggleConfirmationModal(show) {
        this.confirmationModalOpener.classList.toggle('hidden', show);
        this.classicAddButton.classList.toggle('hidden-within-modal', !show);
      }

      checkPersonalizeUrl() {
        if (!location.search) return;

        const params = Object.fromEntries(new URLSearchParams(location.search));

        this.setValuesFromUrl(params);
        this.setDisableConfirmationModalValue(params);

        if (!params.personalize) return;
        this.personalizeModal.show(this.personalizeButton);
      }

      setPersonalizationUrl() {
        if (!this.dataUpdateUrl) return;
        if (Object.fromEntries(new URLSearchParams(location.search)).personalize) return;
        window.history.replaceState(
          {},
          '',
          `${window.location.href}${window.location.search ? '&' : '?'}personalize=true`
        );
      }

      unsetPersonalizationUrl() {
        if (!this.dataUpdateUrl) return;
        if (!window.location.search.includes('personalize')) return;
        let newUrl;
        if (window.location.search.includes('variant')) {
          newUrl = window.location.href.replace('&personalize=true', '');
        } else {
          newUrl = window.location.href.replace('personalize=true&', '').replace('personalize=true', '');
        }
        window.history.replaceState({}, '', `${newUrl}`);
      }

      setInitialValues(type) {
        if ( this.querySelector(`${this.inputStrings.type}:checked`) &&
          this.querySelector(`${this.inputStrings.font}:checked`) ) return;

        const urlObject = Object.fromEntries(new URLSearchParams(location.search));

        if (!urlObject.type) {
          type == 'monogram'
            ? this.querySelector(`${this.inputStrings.type}[value="Monogram"]`).checked = true
            : this.querySelector(`${this.inputStrings.type}[value="Text"]`).checked = true;
        }

        if (!urlObject.font && this.querySelector(`${this.inputStrings.font}:first-child`)) {
          this.querySelector(`${this.inputStrings.font}:first-child`).checked = true;
        }

        if (!urlObject.threadColor && this.querySelector(`${this.inputStrings.threadColor}:first-child`)) {
          this.querySelector(`${this.inputStrings.threadColor}:not([data-disabled])`).checked = true;
        }

        // disable inputs before first interaction with line inputs
        // to prevent adding product with personalization properties but without personalization to the cart
        // e.g (Trunk - No Personalization, Font Miramar, Thread Yellow)
        this.temporaryDisableInputs();
      }

      setFoilStampAndEngravingValues() {
        const urlObject = Object.fromEntries(new URLSearchParams(location.search));
        if (urlObject.font) return;
        this.querySelector(this.inputStrings.font).checked = true;

        // disable inputs before first interaction with line inputs
        // to prevent adding product with personalization properties but without personalization to the cart
        // e.g (Trunk - No Personalization, Font Miramar, Thread Yellow)
        this.temporaryDisableInputs();
      }

      updateInputs() {
        if (!this.values.type) {
          if (this.inputs.line1) {
            this.personalizeImage.updateText(this.personalizeImage.personalizationText)
            this.personalizeImage.updateText(this.personalizeImage.shadowPersonalizationText);
          }
          return;
        }

        let type = 'data-text';

        if (this.values.type == 'Monogram') type = 'data-monogram';

        const selectedFont = Array.from(this.querySelectorAll(this.inputStrings.font))
          .filter((item) => item.closest('div').hasAttribute(type) && item.checked)[0];
        if (!selectedFont) this.querySelector(`.product-form__input-wrapper[${type}] input`).checked = true;

        // toggle
        this.querySelector('.product-form__input-line-2')?.classList.toggle('hidden', (this.values.type == 'Monogram'));
        this.querySelector('.product-form__input-font').classList.toggle('text-active', !(this.values.type == 'Monogram'));
        this.querySelector('.product-form__input-font').classList.toggle('monogram-active', (this.values.type == 'Monogram'));

        // hide all data-monogram and data-text inputs
        this.querySelectorAll('[data-monogram]').forEach(item => item.classList.add('hidden'));
        this.querySelectorAll('[data-text]').forEach(item => item.classList.add('hidden'));

        // show all data-[type] inputs
        this.querySelectorAll(`[data-${this.values.type.toLowerCase()}]`).forEach(item => item.classList.remove('hidden'))

        if (this.values.type == 'Monogram') {
          Array.from(this.personalizeImageWrapper.querySelectorAll('#personalization-text div:first-child .char'))
            .splice(3)
            .forEach((node) => node.remove());

          this.inputs.line2 && (this.inputs.line2.value = '');
          this.querySelector(`#${this.section}-line-2-value`) && (this.querySelector(`#${this.section}-line-2-value`).innerHTML = '');
          this.handleInputsChange(!this.inputs.line1?.value && !this.inputs.line2?.value);
        }

        this.values = this.getValues();
        this.updateUrl();
        this.personalizeImage.updateText(this.personalizeImage.personalizationText)
        this.personalizeImage.updateText(this.personalizeImage.shadowPersonalizationText);

        // disable inputs before first interaction with line inputs
        // to prevent adding product with personalization properties but without personalization to the cart
        // e.g (Trunk - No Personalization, Font Miramar, Thread Yellow)
        if (this.itemPersonalized) {
          this.enableInputs();
        } else {
          this.temporaryDisableInputs();
        }
      }

      updateCharacterCount(target, elementId) {
        this.getProductData();
        const id = target.getAttribute('id') || elementId;
        let maxLength = 0;

        if (!id.includes('line')) return;

        const characterCountWrappers = this.querySelector(`#${id}-characters`)
          .closest('personalize-form')
          .querySelectorAll('[id*="-characters"]');

        if (this.values?.type === 'Monogram') {
          maxLength = 3;

          if (id.includes('line-1')) {
            this.inputs.line1.value = this.inputs.line1.value.toUpperCase();
            this.inputs.line1.value = this.inputs.line1.value.slice(0, 3);
          }
        } else {
          if (this.productData.tags.includes('Mini') || this.productData.tags.includes('mini')) {
            maxLength = 10;
          } else if (this.productType == 'pouches') {
            maxLength = 4;
          } else if (this.personalizationType == 'foil-stamp') {
            this.inputs.line1.value = this.inputs.line1.value.toUpperCase();
            maxLength = 3;
          } else if (this.productType == 'heirloom-gown' || this.productType == 'heirloom-blanket') {
            maxLength = 8;
          } else {
            maxLength = 20;
          }
        }

        this.inputs.line1.setAttribute('maxlength', maxLength);
        this.inputs.line2 && (this.inputs.line2.setAttribute('maxlength', maxLength));

        if (target && target.value.length >= maxLength) {
          target.value = target.value.slice(0, maxLength);
        }

        characterCountWrappers.forEach(wrapper => {
          wrapper.dataset.maxLength = maxLength;
          if (wrapper.id !== `${id}-characters`) return;
          wrapper.textContent = maxLength - (target.value.length || 0);
        });
      }

      updateButtonStyles() {
        if (!this.values.type) return;
        this.inputs.fonts.forEach((el) => {
          el.parentNode.classList.forEach((cl) => {
            if (cl.startsWith('type-')) {
              el.classList.remove(cl);
            }
          });
          if (el.parentNode.dataset[this.values.type.toLowerCase()] === '') {
            el.parentNode.classList.add(`type-${this.values.type.toLowerCase()}`);
          }
        });
      }

      updateLegends() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        fieldsets.forEach((fieldset) => {
          fieldset.querySelector('.form__label span:last-child').textContent =
            Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value || '';
        });
      }

      updateUrl(unsetPersonalizationUrl = false) {
        if (!this.dataUpdateUrl) return;
        const newUrl = new URLSearchParams(
          Object.entries(Object.assign(Object.fromEntries(new URLSearchParams(location.search)), this.values))
            .filter(([key, val]) => val != null && val != undefined)
            .map(([key, val]) => `${key}=${val}`)
            .join('&')
        );
        window.history.replaceState({}, document.title, `${window.location.pathname + '?' + newUrl}`);

        if (unsetPersonalizationUrl) {
          this.unsetPersonalizationUrl();
        } else {
          this.setPersonalizationUrl();
        }

        if (this.addToRegistryCTAs.length) this.addToRegistryCTAs.forEach(item => item.handleUpdateURL());
      }

      setInitials() {
        const line1 = this.querySelector(`.property__input--line-1`);
        line1.value = line1.value.toUpperCase();
      }

      setValuesFromUrl(urlObject) {
        if ((this.inputs.line1 && !urlObject.line1) && (this.inputs.line2 && !urlObject.line2)) {
          this.removePersonalization();
        }

        if (urlObject.line1 && this.inputs.line1) {
          this.inputs.line1.value = this.removeDisabledCharacters({ value: urlObject.line1, fontName: urlObject.font, type: urlObject.type });
        }

        if (urlObject.line2 && this.inputs.line2) {
          this.inputs.line2.value = this.removeDisabledCharacters({ value: urlObject.line2, fontName: urlObject.font, type: urlObject.type });
        }

        if (urlObject.threadColor && this.inputs.threadColors) {
          const preselectedInput = Array.from(this.inputs.threadColors)
            .filter(input => input.value === urlObject.threadColor)[0];

          if (!preselectedInput) return;
          preselectedInput.checked = true;
        }

        if (urlObject.font && this.inputs.fonts) {
          const preselectedInput = Array.from(this.inputs.fonts)
            .filter(input => input.value === urlObject.font)[0];

          if (!preselectedInput) return;
          preselectedInput.checked = true;
        }

        if (urlObject.type && this.inputs.types) {
          const preselectedInput = Array.from(this.inputs.types)
            .filter(input => input.value === urlObject.type)[0];

          if (!preselectedInput) return;
          preselectedInput.checked = true;
        }

        if (this.inputs.line1) {
          this.inputs.line1.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // disable inputs before first interaction with line inputs
        // to prevent adding product with personalization properties but without personalization to the cart
        // e.g (Trunk - No Personalization, Font Miramar, Thread Yellow)
        if (!this.inputs.line1?.value && !this.inputs.line2?.value) {
          this.temporaryDisableInputs();
        } else {
          this.enableInputs();
        }
      }

      setDisableConfirmationModalValue(params) {
        if (!params.disableConfirmationModal) return;

        this.disableConfirmationModalValue = JSON.parse(params.disableConfirmationModal);
        if (!this.disableConfirmationModalValue) return;

        this.toggleConfirmationModal(this.disableConfirmationModalValue);
      }

      getValues() {
        return {
          embroidery: this.productInfo.querySelector(`${this.inputStrings.embroidery}:checked`)?.value || null,
          embroideryCheckbox: this.querySelector(`${this.inputStrings.embroideryCheckbox}[value="Yes"]:checked`) ? true : null,
          type: this.querySelector(`${this.inputStrings.type}:checked`)?.value || null,
          font: this.querySelector(`${this.inputStrings.font}:checked`)?.value || null,
          threadColor: this.querySelector(`${this.inputStrings.threadColor}:checked`)?.value || null,
          foilColor: this.querySelector(`${this.inputStrings.foilColor}:checked`)?.value || null,
          line1: this.querySelector(`${this.inputStrings.line1}`)?.value || null,
          line2: this.querySelector(`${this.inputStrings.line2}`)?.value || null,
        };
      }

      getProductData() {
        this.productData = JSON.parse(this.querySelector('#product-data[type="application/json"]').textContent);
        return this.productData;
      }

      temporaryDisableInputs() {
        this.propertyInputsArray.forEach(input => {
          if (input.checked) {
            // disabling only checked inputs
            input.setAttribute('disabled', '');
          } else if (input.disabled) {
            // if input was disabled but no longer checked - enabling it
            input.removeAttribute('disabled');
          }
        })
      }

      enableInputs() {
        this.propertyInputsArray.forEach(input => {
          if (input.checked || input.disabled) input.removeAttribute('disabled')
        })
      }

      removePersonalization() {
        this.itemPersonalized = false;

        this.values = this.getValues();
        if (this.productType == 'trunks'
          || this.productType == 'heirloom-gown'
          || this.productType == 'heirloom-blanket'
          || this.productType == 'crown'
          || this.productType == 'pouches'
          || this.productType == 'basket'
          || this.productType == 'easter-basket'
        ) {
          const embroideryVariantRadio = this.productInfo.querySelector(
            `${this.inputStrings.embroidery}[value="No Embroidery"]`
          );
          if (embroideryVariantRadio) {
            embroideryVariantRadio.checked = true;
            this.productInfo.querySelector('variant-radios').onVariantChange();
          }
          if (this.querySelector(`${this.inputStrings.embroideryCheckbox}[value="Yes"]`)) {
            this.querySelector(`${this.inputStrings.embroideryCheckbox}[value="Yes"]`).checked = false;
          }
          if (this.querySelector(`${this.inputStrings.type}:checked`)) {
            this.querySelector(`${this.inputStrings.type}:checked`).checked = false;
          }
          if (this.querySelector(`${this.inputStrings.threadColor}:checked`)) {
            this.querySelector(`${this.inputStrings.threadColor}:checked`).checked = false;
          }
          if (this.querySelector(`${this.inputStrings.font}:checked`)) {
            this.querySelector(`${this.inputStrings.font}:checked`).checked = false;
          }
          this.values = this.getValues();
        } else if (this.productType == 'milestone-book') {
          const embossingVariantRadio = this.productInfo.querySelector(
            `${this.inputStrings.embossing}[value="No Embossing"]`
          );
          if (embossingVariantRadio) {
            embossingVariantRadio.checked = true;
            this.productInfo.querySelector('variant-radios').onVariantChange();
          }
          this.querySelector(`${this.inputStrings.foilStampCheckbox}[value="Yes"]`).checked = false;
          if (this.querySelector(`${this.inputStrings.foilColor}:checked`)) {
            this.querySelector(`${this.inputStrings.foilColor}:checked`).checked = false;
          }
        } else if (this.productType == 'heart-padlock' || this.productType == 'accessory-bundle') {
          this.querySelector(`${this.inputStrings.engravingCheckbox}[value="Yes"]`).checked = false;
        } else if (this.personalizationType == 'foil-stamp') {
          const embossingVariantRadio = this.productInfo.querySelector(
            `${this.inputStrings.embossing}[value="No Embossing"]`
          );
          if (embossingVariantRadio) {
            embossingVariantRadio.checked = true;
          }
          this.querySelector(`${this.inputStrings.foilColor}[value="Gold"]`).checked = false;
          this.querySelector(`${this.inputStrings.foilStampCheckbox}[value="Yes"]`).checked = false;
        }

        Array.from(this.querySelectorAll(`${this.inputStrings.type}`))?.forEach((el) => (el.checked = false));

        this.inputs.fonts.forEach((input) => (input.checked = false));
        this.inputs.threadColors.forEach((input) => (input.checked = false));

        this.inputs.line1 && (this.inputs.line1.value = '');
        this.inputs.line2 && (this.inputs.line2.value = '');

        this.querySelectorAll('#personalization-text div').forEach((div) => {
          if (!div.classList.contains('loading__spinner')) {
            div.textContent = ''
          }
        });

        this.handlePersonalizeButton();

        if (this.productInfo.querySelector('variant-radios')) {
          this.productInfo.querySelector('variant-radios').onVariantChange();
        }

        this.values = this.getValues();
        this.updateUrl(true);
      }

      deletePersonalizationIfValuesEmpty() {
        this.values = this.getValues();

        // if the page is downloaded and we do not see the personalization type ...
        // but we see any of the personalization checkboxes set to true - that means something ...
        // went wrong and we should clear the personalization
        if (!this.values.type && (this.values.embroideryCheckbox || this.values.engravingCheckbox || this.values.foilStampCheckbox)) this.removePersonalization();
      }

      handleNextButton() {
        this.personalizeModal.hide();

        const bundleSlider = document.querySelector('bundle-slider-component');
        bundleSlider.scrollIntoView();
        bundleSlider.querySelector('button[name="next"]').dispatchEvent(new Event('click'));
      }

      initThreadGroups() {
        if (!this.fabricsData) return;

        const variantRadios = this.productInfo?.closest('section').querySelector('variant-radios');
        this.currentVariant = variantRadios?.currentVariant || {};

        // init thread groups on page load
        this.handleFabricsChange();

        // watch to variant change
        variantRadios && variantRadios.addEventListener('variant-changed', () => {
          this.currentVariant = variantRadios.currentVariant || {};
          this.handleFabricsChange();
        });
      }

      handleFabricsChange() {
        const currentFabricName = String(this.currentVariant?.options?.[this.fabricsInOptionsIndex] || '').toLowerCase();
        if (currentFabricName === '') return;

        const currentFabricData = this.fabricsData.fabricGroups.find(item => item.fabric === currentFabricName);
        this.handleThreadGroups(currentFabricData);
      }

      handleThreadGroups(currentFabricData) {
        const mainThreads = this.mainThreadGroup.querySelectorAll('[name="properties[Thread Color]"]');
        const additionalThreads = this.additionalThreadGroup.querySelectorAll('[name="properties[Thread Color]"]');
        const generalThreadsCount = this.mainThreadGroup.querySelectorAll('[name="properties[Thread Color]"]').length;

        // if we do not have currentFabricData, we assume that all threads are recommended
        // in other words: we putting all threads in a single group and hiding the other group
        if (!currentFabricData) currentFabricData = { recommendedThreads: Array.from(mainThreads).map(thread => String(thread.value).toLowerCase()) };

        const recommendedThreadsCount = currentFabricData.recommendedThreads.length;

        // toggle groups visibility
        // if all threads are recommended, we hide the additional thread group
        this.mainThreadGroup.toggleAttribute('data-only-group', recommendedThreadsCount === generalThreadsCount);
        this.additionalThreadGroup.toggleAttribute('data-group-disabled', recommendedThreadsCount === generalThreadsCount);

        // loop through main and additional threads to toggle them
        mainThreads.forEach((threadInput, index) => {
          const value = String(threadInput.value).toLowerCase();
          const additionalThreadInput = additionalThreads[index];

          // we use data-disabled attribute instead of actual disabled attribute
          // because disabled attribute is reserved in other methods
          // e.g. temporaryDisableInputs() - method that disable all inputs
          if (currentFabricData.recommendedThreads.includes(value)) {
            threadInput.removeAttribute('data-disabled');
            additionalThreadInput.setAttribute('data-disabled', '');
          } else {
            threadInput.setAttribute('data-disabled', '');
            additionalThreadInput.removeAttribute('data-disabled');
          }

          // switch inputs if it checked but becomes disabled
          if (threadInput.checked && threadInput.getAttribute('data-disabled') !== null) {
            threadInput.checked = false;
            additionalThreadInput.checked = true;
          }

          // switch inputs if it checked but becomes disabled
          if (additionalThreadInput.checked && additionalThreadInput.getAttribute('data-disabled') !== null) {
            additionalThreadInput.checked = false;
            threadInput.checked = true;
          }
        });

        // update legends in case there is a chance that checked input ...
        // ... was switched, but the legend title was not updated
        this.updateLegends()
      }
    }
  );
}

if (!customElements.get('personalization-confirmation-buttons')) {
  customElements.define(
    'personalization-confirmation-buttons',
    class PersonalizationConfirmationButtons extends HTMLElement {
      constructor() {
        super();

        this.submitProductFormBtn = this.querySelector('[name="add"]');
        this.productForm = this.submitProductFormBtn.form;
        this.personalizeBtn = this.querySelector('.button--personalize');
        this.modal = this.closest('personalization-confirmation-modal');
        this.personalizeModal = document.querySelector(`personalize-modal[id=${this.personalizeBtn.getAttribute('aria-controls')}]`) || document.querySelector('personalize-modal');
        this.personalizeModalOpener = document.querySelector(`[data-modal='#${this.personalizeModal.id}']`).querySelector('button');

        document.addEventListener('DOMContentLoaded', () => this.eventListeners())
      }

      eventListeners() {
        this.productForm.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.personalizeBtn.addEventListener('click', this.openPersonalizeModal.bind(this))
      }

      onSubmitHandler() {
        this.modal.hide();
      }

      openPersonalizeModal() {
        this.modal.hide();
        this.personalizeModal.show(this.personalizeModalOpener);
      }
    }
  );
}

if (!customElements.get('personalization-confirmation-modal')) {
  customElements.define(
    'personalization-confirmation-modal',
    class PersonalizationConfirmationModal extends ModalDialog {
      constructor() {
        super();
      }

      show(opener, type = 'modal') {
        super.show();

        this.handleTypeChange(type);
      }

      handleTypeChange(type) {
        if (!this.querySelector('add-to-registry')) return;

        const addToRegistry = this.querySelector('add-to-registry');
        const addToCart = this.querySelector('[name="add"]');

        addToRegistry.classList.toggle('hidden', (type !== 'registry'));
        addToCart.classList.toggle('hidden', (type === 'registry'));
      }
    }
  );
}
